var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: {
            trigger: _vm.trigger,
            content: _vm.content,
            offset: 5,
            placement: "right",
            container: _vm.container,
          },
          expression:
            "{\n    trigger,\n    content: content,\n    offset: 5,\n    placement: 'right',\n    container,\n  }",
        },
      ],
      staticClass:
        "flex-shrink-0 inline-flex items-center justify-center w-4 h-4 border rounded-full cursor-pointer transition duration-300 focus:outline-none focus:opacity-40 leading-none",
      class: {
        "border-theme text-theme hover:opacity-70": _vm.themed,
        "border-grey-darker text-grey-darker hover:text-black hover:border-black":
          !_vm.themed,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("span", { staticClass: "text-xxxs font-semibold" }, [_vm._v("?")]),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Info")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }